import {
  appointmentsFailure,
  appointmentsRequest,
  appointmentsSuccess,
  inventoryFailure,
  inventoryRequest,
  inventorySuccess,
  setGroomerUuid,
} from 'store/reducers/inventory';

import { fetchData } from './fetchData';

export const getAllInventory =
  ({ dateStart, dateEnd }) =>
  (dispatch, getState) => {
    const luid = getState().provider.locations[0].uuid;
    return fetchData({
      endpoint: `location/${luid}/inventory?date_start=${dateStart}&date_end=${dateEnd}`,
      actions: [inventoryRequest, inventorySuccess, inventoryFailure],
    })(dispatch, getState);
  };

export const getAppointments =
  ({ dateStart, dateEnd }) =>
  (dispatch, getState) => {
    const luid = getState().provider.locations[0].uuid;
    const { uuid } = getState().ui.selectedGroomer;
    const userUuidQuery = uuid && uuid !== 'all' ? `&user_uuid=${uuid}` : '';

    return fetchData({
      endpoint: `location/${luid}/appointments/calendar?date_start=${dateStart}&date_end=${dateEnd}${userUuidQuery}`,
      actions: [appointmentsRequest, appointmentsSuccess, appointmentsFailure],
    })(dispatch, getState);
  };

export const getGroomerInventory =
  ({ dateStart, dateEnd }) =>
  (dispatch, getState) => {
    const luid = getState().provider.locations[0].uuid;
    const { uuid } = getState().ui.selectedGroomer;
    return fetchData({
      endpoint: `location/${luid}/user/${uuid}/inventory?date_start=${dateStart}&date_end=${dateEnd}`,
      actions: [inventoryRequest, inventorySuccess, inventoryFailure],
    })(dispatch, getState).then(({ success, data }) => {
      if (success) {
        dispatch(setGroomerUuid(uuid));
        return { success, data };
      }
    });
  };

export const editSingleInventory =
  ({ body }) =>
  (dispatch, getState) => {
    const luid = getState().provider.locations[0].uuid;
    const { uuid } = getState().ui.selectedGroomer;
    return fetchData({
      endpoint: `inventory/location/${luid}/user/${uuid}/bulk`,
      actions: [null, null, null],
      httpMethod: 'patch',
      body,
    })(dispatch, getState);
  };

// Recurring inventory 👇

export const postGroomerRecurringInventory = (body) => (dispatch, getState) => {
  const luid = getState().provider.locations[0].uuid;
  const { uuid } = getState().ui.selectedGroomer;
  return fetchData({
    endpoint: `inventory/${luid}/users/${uuid}/recurring`,
    actions: [null, null, null],
    httpMethod: 'post',
    body,
  })(dispatch, getState);
};

export const deleteGroomerRecurringInventory =
  (body) => (dispatch, getState) => {
    const luid = getState().provider.locations[0].uuid;
    const { uuid } = getState().ui.selectedGroomer;
    return fetchData({
      endpoint: `inventory/${luid}/users/${uuid}/recurring`,
      actions: [null, null, null],
      httpMethod: 'delete',
      hideErrorToast: true,
      body,
    })(dispatch, getState);
  };
